import { render, staticRenderFns } from "./OcrResultDrawer.vue?vue&type=template&id=5f8f29ee&scoped=true&"
import script from "./OcrResultDrawer.vue?vue&type=script&lang=js&"
export * from "./OcrResultDrawer.vue?vue&type=script&lang=js&"
import style0 from "./OcrResultDrawer.vue?vue&type=style&index=0&id=5f8f29ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8f29ee",
  null
  
)

export default component.exports